export const CHECKOUT_URL = 'https://logopedia-pro.impultienda.ar/checkout'
export const OFFER_ANCHOR = '#offerta'
export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/uS5awXui7FWaf6U287MHG1/Diseno-sin-titulo-3.webp'
export const CTA_LABEL = '🚀 SÌ! VOGLIO LOGOPEDIA PRO™ ORA'
export const RATING_LINE = '⭐⭐⭐⭐⭐ 4.9/5 — Recensioni Verificate dai Professionisti'
export const GUARANTEE_LINE = '🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi'
